import React from "react";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { GridColumnHeaderParams } from "@mui/x-data-grid";
import { useStore } from "../../../store";
import { DataGrid } from "../../../components";
import moment from "moment";
import { useCookies } from "react-cookie";

const Table = () => {
  const {
    TemplatesStore: {
      gridOption: {
        columns,
        rows,
        totalCount,
        loading,
        page,
        rowsPerPage,
        sort,
      },
      setRows,
      setGridOption,
      onPageSizeChange,
      onPageChange,
      isBlind,
    },
  } = useStore();
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies();
  const expires = moment().add("100", "y").toDate();

  const headerClickEvent = (item: GridColumnHeaderParams) => {
    if (item.field !== "createdAt") return;
    if (sort === "desc") {
      setCookie("tSort", "asc", { path: "/", expires });
      setGridOption({ page: 0, sort: "asc" });
      setRows();
    } else if (sort === "asc") {
      setCookie("tSort", "desc", { path: "/", expires });
      setGridOption({ page: 0, sort: "desc" });
      setRows();
    }
  };

  const onColumnVisibilityChange = (params: any) => {
    const savedHiddenColumns = localStorage.getItem("columns");
    if (savedHiddenColumns !== null) {
      const arr = JSON.parse(savedHiddenColumns);
      let result = arr;
      if (params.isVisible) {
        result = result.filter((el: any) => {
          return el !== params.field;
        });
      } else {
        result.push(params.field);
      }
      localStorage.setItem("columns", JSON.stringify(result));
    } else {
      localStorage.setItem("columns", JSON.stringify([`${params.field}`]));
    }
  };

  const handleCellClick = (params: any, event: any) => {
    event.preventDefault();
    if (params.field !== "reviewer") {
      navigate(`/templates/${params.row.templateId}`);
    }
  };

  const getRowClassName = (params: any) => {
    if (params.row.reviewStatus === "Rejected") {
      return "is-rejected";
    } else if (params.row.reviewStatus === "Published") {
      return "is-published";
    } else if (params.row.reviewer !== "") {
      return "is-reviewer";
    } else {
      return "";
    }
  };

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      totalCount={totalCount}
      loading={loading}
      page={page}
      // rowClickEvent={rowClickEvent}
      rowHeight={72}
      rowsPerPage={rowsPerPage}
      onPageSizeChange={onPageSizeChange}
      onPageChange={onPageChange}
      handleColumnHeaderClick={headerClickEvent}
      onCellClick={handleCellClick}
      getRowClassName={getRowClassName}
      onColumnVisibilityChange={onColumnVisibilityChange}
    />
  );
};

export default observer(Table);
